<template lang="pug">
  v-chip(
    v-bind="extendAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import { VChip } from 'vuetify/lib';

export default {
  components:  { VChip },
  props: {
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    clean: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      return {
        ripple: false,
        color: 'ui-background',
        closeIcon: '$ui-close',
        class: [
          'dv-chip',
          'rounded-10',
          'ui-body-1',
          ...(this.clean ? ['clean'] : []),
        ],
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-chip {
  $height: calc(v-bind(height) * 1px);
  $width: calc(v-bind(width) * 1px);
  padding: 8px 16px;
  &.clean {
    &::before,
    &::after {
      content: '';
      display: none !important;
    }
  }
  @if $height {
    height: $height
  }
  @if $width {
    width: $width
  }
  &::v-deep .v-chip__content {
    height: unset;
    & > .v-chip__close {
      font-size: 20px !important;
      height: 20px !important;
      width: 20px !important;
      margin-right: 0px !important;
      margin-left: 8px !important;
    }
  }
}
</style>
